import React, { useEffect, useState, useRef } from "react";
import "./Sidebar.css";
import { Container } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";
import apiCall from "../API/API";
import "bootstrap/dist/css/bootstrap.min.css";
import { AiFillHome } from "react-icons/ai";
import { IoIosPeople } from "react-icons/io";
import { BsFillCartCheckFill } from "react-icons/bs";
import { MdCreditScore, MdToken } from "react-icons/md";
import { RiFolderTransferLine } from "react-icons/ri";
import { IoIosLogOut } from "react-icons/io";
import { RiFundsBoxFill } from "react-icons/ri";
import { RiFundsLine } from "react-icons/ri";
import { AiTwotoneFund } from "react-icons/ai";
import { RiRefund2Line } from "react-icons/ri";
import { SiHiveBlockchain } from "react-icons/si";
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import { RiExchangeFundsLine } from "react-icons/ri";
import { BiTransferAlt } from "react-icons/bi";
import { BsChevronDown } from "react-icons/bs";
import { IoIosPersonAdd } from "react-icons/io";
import { BsShop } from "react-icons/bs";
import { BiPackage } from "react-icons/bi";
import { IoMdWallet } from "react-icons/io";
import { RiTeamLine } from "react-icons/ri";
import { PiHandDepositFill } from "react-icons/pi";
import { RxLoop } from "react-icons/rx";
import { RiUserSettingsFill } from "react-icons/ri";
import { GiLetterBomb } from "react-icons/gi";
import { SiBnbchain } from "react-icons/si";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdSettings } from "react-icons/io";
import { FaBolt, FaChartPie, FaCrown, FaHandHoldingUsd, FaMoneyBillAlt, FaMoneyCheckAlt, FaUserClock, FaUserSlash } from "react-icons/fa";
import NavPages from "../NavPages";
import { useAdminAccess, canOpen, clearAdminAccess } from "../Config/adminAccess";
import { useNavigate } from "react-router-dom";
import { BsHddStackFill } from "react-icons/bs";
import Change from "../Common/StringToSub";
import useWindowDimensions from "../Common/useWindowDimensions";
import { useSelector, useDispatch } from "react-redux";
import { Data } from "../Common/Data";
import { IoQrCodeSharp } from "react-icons/io5";
import { BsBank2 } from "react-icons/bs";
import { IoNewspaperOutline } from "react-icons/io5";
import { GiReceiveMoney } from "react-icons/gi";
import { FaGifts } from "react-icons/fa6";
import { MdVerified } from "react-icons/md";
import { GiConfirmed } from "react-icons/gi";
import { MyDelay } from "../Common/Data";
import { BiMoneyWithdraw } from "react-icons/bi";
import { GiTakeMyMoney } from "react-icons/gi";
import { TbReportMoney } from "react-icons/tb";
import { fetchDashboardData } from "../Actions/adminActions";
import { IoCopy } from "react-icons/io5";
import CopyFromtag from "../Common/CopyFromtag";
import ConnectButton from "../Component/ConnectButton";
import { logout } from "../Actions/adminActions";
import { RiUserSharedLine } from "react-icons/ri";
import { MdOutlineSupportAgent } from "react-icons/md";
import { FaMoneyCheck } from "react-icons/fa6";
import { CiMoneyBill } from "react-icons/ci";
import { PiHandWithdrawFill } from "react-icons/pi";
import { MdKey } from "react-icons/md";
import { MdAssuredWorkload } from "react-icons/md";
import { RiTeamFill } from "react-icons/ri";
import { toast } from "react-toastify";
// import WalletButton from "../Component/WalletButton";

const Sidebar = () => {
  const access = useAdminAccess();
  const isAdmin = access?.role === "admin";
  const can = (page) => canOpen(access, page);
  const location = useLocation();

  // Pending activation requests, shown next to the menu item; refreshed on page change,
  // every minute, and right after a request is approved / rejected (event from that page)
  const [pendingActivations, setPendingActivations] = useState(null);
  const canSeeActivations = can("activation_requests");
  useEffect(() => {
    if (!canSeeActivations) return undefined;
    let alive = true;
    const refresh = async () => {
      const { data } = await apiCall("GET", "/activation-requests?status=0&limit=1");
      if (alive && data?.summary) setPendingActivations(Number(data.summary.pending) || 0);
    };
    refresh();
    const timer = setInterval(refresh, 60000);
    window.addEventListener("activation-requests-changed", refresh);
    return () => {
      alive = false;
      clearInterval(timer);
      window.removeEventListener("activation-requests-changed", refresh);
    };
  }, [canSeeActivations, location.pathname]);
  // Pending PAN / Aadhaar KYC requests, shown the same way
  const [pendingKyc, setPendingKyc] = useState(null);
  const canSeeKyc = can("kyc_detail") || can("aadhar_kyc_detail");
  useEffect(() => {
    if (!canSeeKyc) return undefined;
    let alive = true;
    const refresh = async () => {
      const { data } = await apiCall("GET", "/kyc-review/counts");
      if (alive && data?.data) setPendingKyc({ pan: Number(data.data.pan) || 0, aadhar: Number(data.data.aadhar) || 0 });
    };
    refresh();
    const timer = setInterval(refresh, 60000);
    window.addEventListener("kyc-requests-changed", refresh);
    return () => {
      alive = false;
      clearInterval(timer);
      window.removeEventListener("kyc-requests-changed", refresh);
    };
  }, [canSeeKyc, location.pathname]);
  const kycBadge = (n) =>
    n === undefined || n === null ? null : (
      <div className="reminder" style={{ backgroundColor: n === 0 ? "green" : "red" }} title={`${n} pending`}>
        {n}
      </div>
    );
  const { loading, error, user } = useSelector((state) => state.admin);
  const navigate = useNavigate();
  useEffect(() => {
    if (error?.code === 419) {
      navigate("/");
    }
  }, [error]);
  // const acc = useSelector((state) => state.account.value);

  const userAddress = localStorage.getItem("userAddress");
  const [openDropdown, setOpenDropdown] = useState(null);

  const { height, width } = useWindowDimensions();
  const hasFetchedData = useRef(false);
  const [toggle, setToggle] = useState("0");

  async function Logout() {
    try {
      await MyDelay(500);

      const response = await apiCall("POST", "/logout");
      console.log("Logout response:", response);
      // if(response?.data?.success){
      //   dispatch(logout());
      //   navigate("/", { replace: true });
      // }else {
      //   toast.error("Logout failed. Please try again.");
      // }
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      clearAdminAccess();
      dispatch(logout());
      navigate("/", { replace: true });
    }
  }

  useEffect(() => {
    if (error?.code === 419) {
      navigate("/", { replace: true });
    }
  }, [error, navigate]);

  useEffect(() => {
    if (width < 900) {
      setToggle("-260px");
    }
  }, [width]);

  const dispatch = useDispatch();
  const { dashboardData } = useSelector((state) => state.admin);
  useEffect(() => {
    if (!hasFetchedData.current) {
      dispatch(fetchDashboardData());
      hasFetchedData.current = true;
    }
  }, []);
  const handleDropdownToggle = (dropdownName) => {
    setOpenDropdown((prevState) =>
      prevState === dropdownName ? null : dropdownName
    );
  };

  return (
    <React.Fragment>
      <Container fluid className="p-0">
        <div id="sidebar-wrapper" className="" style={{ left: toggle }}>
          <div id="sidebarTopDiv">
            <div className="logo">
              <img
                src={Data.logoIc}
                alt="logo.png"
                height="auto"
                width="100px"
              />
            </div>
          </div>
          <section style={{ padding: "5px", marginTop: "80px" }}>
            <div className="logowithtext">
              {/* <img src={Data.logo} alt="logo.png" /> */}
              <h3 className="m-0">
                User Name <div></div>
              </h3>
              <p>{Change(userAddress)} </p>
            </div>
            {can("") && (
            <NavLink
              to=""
              end
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <AiFillHome />
                </i>
                <h4 className="m-0">Dashboard</h4>
              </div>
            </NavLink>
            )}
            {can("activation_requests") && (
            <NavLink
              to="activation_requests"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <BsShop />
                </i>
                <h4 className="m-0">Activation Requests</h4>
                {pendingActivations !== null && (
                  <div
                    className="reminder"
                    style={{ backgroundColor: pendingActivations === 0 ? "green" : "red" }}
                    title={`${pendingActivations} pending`}
                  >
                    {pendingActivations}
                  </div>
                )}
              </div>
            </NavLink>
            )}
            {can("deposit_accounts") && (
            <NavLink
              to="deposit_accounts"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <AiOutlineFundProjectionScreen />
                </i>
                <h4 className="m-0">Deposit Accounts</h4>
              </div>
            </NavLink>
            )}
            {["all_users", "register_user", "user_bank_details", "rank", "team_income"].some(can) && (
            <div
              className="dropdownitems"
              onClick={() => handleDropdownToggle("users")}
            >
              <div className={`head items`}>
                <i>
                  <IoIosPeople />
                </i>
                <h4 className="m-0">Users</h4>
                <i
                  className="dropicon"
                  style={{
                    transform: `rotate(${
                      openDropdown === "users" ? "180deg" : "0deg"
                    })`,
                  }}
                >
                  <BsChevronDown />
                </i>
              </div>
              {openDropdown === "users" && (
                <div className="dropdown">
                  {can("all_users") && (
                  <NavLink
                    to="all_users"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <GiLetterBomb />
                      </i>
                      <h4 className="m-0">All Users</h4>
                    </div>
                  </NavLink>
                  )}
                  {can("without_sponsor") && (
                  <NavLink
                    to="without_sponsor"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <FaUserSlash />
                      </i>
                      <h4 className="m-0">Without Sponsor</h4>
                    </div>
                  </NavLink>
                  )}
                  {can("old_users") && (
                  <NavLink
                    to="old_users"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <FaUserClock />
                      </i>
                      <h4 className="m-0">Old Users</h4>
                    </div>
                  </NavLink>
                  )}
                  {can("give_power") && (
                  <NavLink
                    to="give_power"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <FaBolt />
                      </i>
                      <h4 className="m-0">Give Power</h4>
                    </div>
                  </NavLink>
                  )}
                  {can("team_income") && (
                  <NavLink
                    to="team_income"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <FaChartPie />
                      </i>
                      <h4 className="m-0">Team Income</h4>
                    </div>
                  </NavLink>
                  )}

                  {can("register_user") && (
                  <NavLink
                    to="register_user"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <IoIosPersonAdd />
                      </i>
                      <h4 className="m-0">Register User</h4>
                    </div>
                  </NavLink>
                  )}

                  {can("user_bank_details") && (
                  <NavLink
                    to="user_bank_details"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <GiLetterBomb />
                      </i>
                      <h4 className="m-0">User Bank Details</h4>
                    </div>
                  </NavLink>
                  )}

                  {can("advisor_ranks") && (
                  <NavLink
                    to="advisor_ranks"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <FaCrown />
                      </i>
                      <h4 className="m-0">Advisor Ranks</h4>
                    </div>
                  </NavLink>
                  )}

                  {can("rank") && (
                  <NavLink
                    to="rank"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <FaGifts />
                      </i>
                      <h4 className="m-0">Reward Achievers</h4>
                    </div>
                  </NavLink>
                  )}

                  {/*<NavLink
                    to="team_development_bonus_user"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <FaGifts />
                      </i>
                      <h4 className="m-0">Team Development Bonus</h4>
                    </div>
                  </NavLink>
                  */}
                </div>
              )}
            </div>
            )}

              
            {can("kyc_detail") && (
            <NavLink
              to="kyc_detail"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <AiOutlineFundProjectionScreen />
                </i>
                <h4 className="m-0">Pan KYC</h4>
                {kycBadge(pendingKyc?.pan)}
              </div>
            </NavLink>
            )}

            {can("aadhar_kyc_detail") && (
            <NavLink
              to="aadhar_kyc_detail"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <AiOutlineFundProjectionScreen />
                </i>
                <h4 className="m-0">Aadhar KYC</h4>
                {kycBadge(pendingKyc?.aadhar)}
              </div>
            </NavLink>
            )}


            {can("withdraw_controls") && (
            <NavLink
              to="withdraw_controls"
              activeClassName="active"
              onClick={(e) => {
                e.stopPropagation();
                if (width < 800) {
                  setToggle("-260px");
                }
              }}
            >
              <div className="items">
                <i>
                  <BiMoneyWithdraw />
                </i>
                <h4 className="m-0">Withdrawal</h4>
                <div
                  className="reminder"
                  style={{
                    backgroundColor:
                      dashboardData?.countPendingWithdrawals === 0
                        ? "green"
                        : "red",
                  }}
                >
                  {dashboardData?.countPendingWithdrawals}
                </div>
              </div>
            </NavLink>
            )}

            {/* <NavLink
              to="principal_withdrawal"
              activeClassName="active"
              onClick={(e) => {
                e.stopPropagation();
                if (width < 800) {
                  setToggle("-260px");
                }
              }}
            >
              <div className="items">
                <i>
                  <PiHandWithdrawFill />
                </i>
                <h4 className="m-0">Principle Withdrawal</h4>
                <div
                  className="reminder"
                  style={{
                    backgroundColor:
                      dashboardData?.countPendingPrincipalWithdrawals === 0
                        ? "green"
                        : "red",
                  }}
                >
                  {dashboardData?.countPendingPrincipalWithdrawals}
                </div>
              </div>
            </NavLink>

            <NavLink
              to="token_withdraw_controls"
              activeClassName="active"
              onClick={(e) => {
                e.stopPropagation();
                if (width < 800) {
                  setToggle("-260px");
                }
              }}
            >
              <div className="items">
                <i>
                  <MdToken />
                </i>
                <h4 className="m-0">Token Withdrawal</h4>
                <div
                  className="reminder"
                  style={{
                    backgroundColor:
                      dashboardData?.countTokenPendingWithdrawals === 0
                        ? "green"
                        : "red",
                  }}
                >
                  {dashboardData?.countTokenPendingWithdrawals}
                </div>
              </div>
            </NavLink> */}

            {can("payout_ledger") && (
            <NavLink
              to="payout_ledger"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <FaMoneyCheckAlt />
                </i>
                <h4 className="m-0">Payout Ledger</h4>
              </div>
            </NavLink>
            )}
            {can("id_settlement") && (
            <NavLink
              to="id_settlement"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <FaHandHoldingUsd />
                </i>
                <h4 className="m-0">ID Settlement</h4>
              </div>
            </NavLink>
            )}
            {can("payout_controls") && (
            <NavLink
              to="payout_controls"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <FaMoneyCheckAlt />
                </i>
                <h4 className="m-0">Payout Report</h4>
              </div>
            </NavLink>
            )}

            {/* <NavLink
              to="release_income_controls"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <FaMoneyCheck />
                </i>
                <h4 className="m-0">Release Income</h4>
              </div>
            </NavLink> */}

            {can("orders") && (
            <NavLink
              to="orders"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <BsFillCartCheckFill />
                </i>
                <h4 className="m-0">Orders</h4>
              </div>
            </NavLink>
            )}

            {/* <NavLink
              to="wealth_lock_history"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <BsFillCartCheckFill />
                </i>
                <h4 className="m-0">Wealth Lock History</h4>
              </div>
            </NavLink> */}

           {/* <div
              className="dropdownitems"
              onClick={() => handleDropdownToggle("dummyData")}
            >
              <div className={`head items`}>
                <i>
                  <RiUserSettingsFill />
                </i>
                <h4 className="m-0">Dummy Data</h4>
                <i
                  className="dropicon"
                  style={{
                    transform: `rotate(${
                      openDropdown === "dummyData" ? "180deg" : "0deg"
                    })`,
                  }}
                >
                  <BsChevronDown />
                </i>
              </div>
              {openDropdown === "dummyData" && (
                <div className="dropdown">
                  <NavLink
                    to="register_user"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) setToggle("-260px");
                    }}
                  >
                    <div className="items">
                      <i>
                        <IoIosPersonAdd />
                      </i>
                      <h4 className="m-0">Register User</h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="dummy_user_stats"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) setToggle("-260px");
                    }}
                  >
                    <div className="items">
                      <i>
                        <IoMdWallet />
                      </i>
                      <h4 className="m-0">Dummy User Stats</h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="dummy_team_update"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) setToggle("-260px");
                    }}
                  >
                    <div className="items">
                      <i>
                        <RiTeamLine />
                      </i>
                      <h4 className="m-0">Dummy User Team</h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="buy_order"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) setToggle("-260px");
                    }}
                  >
                    <div className="items">
                      <i>
                        <BiPackage />
                      </i>
                      <h4 className="m-0">Add Fake Order</h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="place_withdrawal"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) setToggle("-260px");
                    }}
                  >
                    <div className="items">
                      <i>
                        <PiHandDepositFill />
                      </i>
                      <h4 className="m-0">Add Fake Withdrawal</h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="automate_entries"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) setToggle("-260px");
                    }}
                  >
                    <div className="items">
                      <i>
                        <RxLoop />
                      </i>
                      <h4 className="m-0">Automate Dummy Entries</h4>
                    </div>
                  </NavLink>
                </div>
              )}
            </div>*/}

            {can("news") && (
            <NavLink
              to="news"
              activeClassName="active"
              onClick={(e) => {
                e.stopPropagation();
                if (width < 800) {
                  setToggle("-260px");
                }
              }}
            >
              <div className="items">
                <i>
                  <IoNewspaperOutline />
                </i>
                <h4 className="m-0">News</h4>
              </div>
            </NavLink>
            )}
            {/* <NavLink
              to="enable_2fa"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <MdKey />
                </i>
                <h4 className="m-0">Two-Factor Authentication</h4>
              </div>
            </NavLink> */}

            {can("support") && (
            <NavLink
              to="support"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <MdOutlineSupportAgent />
                </i>
                <h4 className="m-0">Support</h4>
              </div>
            </NavLink>
            )}

            {isAdmin && (
              <>
                <NavLink
                  to="sub_admins"
                  activeClassName="active"
                  onClick={() => (width < 800 ? setToggle("-260px") : "")}
                >
                  <div className="items">
                    <i>
                      <RiUserSettingsFill />
                    </i>
                    <h4 className="m-0">Sub Admins</h4>
                  </div>
                </NavLink>
                <NavLink
                  to="audit_log"
                  activeClassName="active"
                  onClick={() => (width < 800 ? setToggle("-260px") : "")}
                >
                  <div className="items">
                    <i>
                      <BsHddStackFill />
                    </i>
                    <h4 className="m-0">Audit Log</h4>
                  </div>
                </NavLink>
              </>
            )}

            {isAdmin && (
            <div
              className="dropdownitems"
              onClick={() => handleDropdownToggle("settings")}
            >
              <div className={`head items`}>
                <i>
                  <IoMdSettings />
                </i>
                <h4 className="m-0">Settings</h4>
                <i
                  className="dropicon"
                  style={{
                    transform: `rotate(${
                      openDropdown === "settings" ? "180deg" : "0deg"
                    })`,
                  }}
                >
                  <BsChevronDown />
                </i>
              </div>
              {openDropdown === "settings" && (
                <div className="dropdown">
                  {can("plan_settings") && (
                  <NavLink
                    to="plan_settings"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <IoMdSettings />
                      </i>
                      <h4 className="m-0">Plan Settings</h4>
                    </div>
                  </NavLink>
                  )}
                  {/* <NavLink
                    to="token_distribution"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <MdToken />
                      </i>
                      <h4 className="m-0">Token Distribution</h4>
                    </div>
                  </NavLink> */}
                  {/* <NavLink
                    to="confirm_package_manually"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <GiConfirmed />
                      </i>
                      <h4 className="m-0">Confirm Package Manually</h4>
                    </div>
                  </NavLink> */}
                  {/* <NavLink
                    to="coin_settings"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <BsHddStackFill />
                      </i>
                      <h4 className="m-0">Coin Setting</h4>
                    </div>
                  </NavLink> */}
                  {can("email_req_status") && (
                  <NavLink
                    to="email_req_status"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <RiUserSettingsFill />
                      </i>
                      <h4 className="m-0">Email Verification Req</h4>
                    </div>
                  </NavLink>
                  )}
                </div>
              )}
            </div>
            )}

            <div className="items" onClick={Logout}>
              <i>
                <IoIosLogOut />
              </i>
              <h4 className="m-0">Logout</h4>
            </div>
          </section>
        </div>
        <div
          id="page-content"
          className="p-0"
          style={{
            background: "#F4F7FC",
            minHeight: "100vh",
            marginLeft:
              width > 900 ? (toggle === "-260px" ? "0px" : "260px") : "0px",
          }}
        >
          <div className="navMain">
            <div
              className="topNavbar"
              style={{
                left: width > 900 ? (toggle === "-260px" ? "0px" : "260px") : "0px",
                right: 0,
                width: "auto",
              }}
            >
              <i
                onClick={() =>
                  toggle === "-260px" ? setToggle("0") : setToggle("-260px")
                }
                style={{ cursor: "pointer" }}
              >
                <GiHamburgerMenu />
              </i>

              <button type="button" className="topNavbar-logout" onClick={Logout} title="Logout">
                <IoIosLogOut />
                <span>Logout</span>
              </button>

              {/* <WalletButton screenWidth={width} toggle={toggle} /> */}
              {/* <ConnectButton screenWidth={width} toggle={toggle} /> */}
            </div>
          </div>

          <div style={{ margin: "80px 5px" }}>{<NavPages />}</div>
        </div>
      </Container>
    </React.Fragment>
  );
};
export default Sidebar;
